import React from "react";

import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./Button.module.css";
import Loader from "./Loader";

interface ButtonProps {
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  design?: "white" | "outline" | "outline-blue" | "";
  fontSize?: string;
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  name?: string;
  autoWidth?: boolean;
}

const Button = ({
  href = "",
  onClick = () => {},
  className = "",
  type = "button",
  name = "",
  design = "",
  fontSize = "base",
  disabled = false,
  loading = false,
  autoWidth = false,
  children,
}: ButtonProps) => {
  const getClassNames = (): string => {
    let classes = className || "";

    if (design === "white") {
      classes += " bg-white text-blue hover:bg-blue-hover hover:text-white";
    } else if (design === "outline") {
      classes +=
        " bg-blue text-white border-2 border-white hover:bg-white hover:text-blue-hover";
    } else if (design === "outline-blue") {
      classes +=
        " bg-white text-blue border-2 border-blue hover:border-blue-hover hover:text-blue-hover";
    } else {
      classes +=
        " border-2 border-blue bg-blue text-white hover:bg-blue-hover hover:border-blue-hover";
    }

    if (disabled) {
      classes += " opacity-50 cursor-not-allowed";
    }

    // Add default styles
    classes += ` text-${fontSize} text-center transition-colors uppercase rounded-full inline-block px-6 py-3  ${
      autoWidth ? "min-w-fit" : " min-w-[250px]"
    }`;
    return classes;
  };

  const handleClick = () => {
    if (loading || disabled) return;
    onClick();
  };

  const classes = getClassNames();

  if (href.length > 0) {
    return (
      <Link to={href} className={classes} onClick={handleClick}>
        <div className={classNames("min-w-fit", styles.inner)}>
          {children}
          {loading && <Loader />}
        </div>
      </Link>
    );
  }

  return (
    <button
      className={classes}
      disabled={disabled}
      type={!loading ? type : "button"}
      onClick={handleClick}
      name={name}
    >
      <div className={classNames("min-w-fit", styles.inner)}>
        {children}
        {loading && <Loader />}
      </div>
    </button>
  );
};

export default Button;
